import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { HaveImage, Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { DottedList } from '../../layoutPages/containers/DottedList';
import { MainCard } from '../../layoutPages/components/MainCard';
import ChangeHistoryTwoToneIcon from '@mui/icons-material/ChangeHistoryTwoTone';
import StarsIcon from '@mui/icons-material/Stars';
import WebIcon from '@mui/icons-material/Web';
import { mathMenuData } from '../../data/SubjectMenu/mathMenuData';
import { MainCards } from '../../layoutPages/containers/MainCards';
import { MaterialList, MaterialWithLink } from '../../layoutPages/components/MaterialList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export function school_report() {

    const data: Array<MaterialWithLink> = [
        { name: "22-23年度校務報告", src: "https://www.pkps.edu.hk/pdf/2024-2025/report/2/22-23.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "23-24年度校務報告", src: "https://www.pkps.edu.hk/pdf/2024-2025/report/2/23-24.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "24-25年度校務報告", src: "https://www.pkps.edu.hk/pdf/report/school_report/2425.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },

    ]

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='計劃/報告 | 校務報告' size='h3' />

            <Grid item xs={11} sm={10} sx={{ p: 2 }}>
               
                <Paragraph title="" sx={{ mt: 2 }}
                instantAppear
                    data={[
                        <MaterialList data={data} />]}
                />

            </Grid>

        </Grid>
    )


}